// src/services/authService.js
import axios from "axios";
import { Auth } from "../services/authService";

const authController = new Auth();
const { BACKEND_URL } = require("../config/config");

export function obtenerOficinas() {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/oficina`;
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export function crearOficina(payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/oficina`;
  return axios.post(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function evaluaPermisoPorOficinasDeUsuario(payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/checkUserOfficeAccess`;
  return axios.post(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function actualizarOficina(idOficina, payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/oficina/${idOficina}`;
  return axios.put(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function eliminarOficina(idOficina) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/oficina/${idOficina}`;
  return axios.delete(url, {
    headers: {
      Authorization: token,
    },
  });
}
